/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type IssueTypeSchemesDirectory from '@jira/spa-apps__admin-pages-issue-types-issue-type-schemes-directory/src/IssueTypeSchemesDirectory.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyIssueTypeSchemesDirectory: LazyComponent<
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<any, any>) => React.JSX.Element
> = lazyForPaint<typeof IssueTypeSchemesDirectory>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-issue-type-schemes-directory", jiraSpaEntry: "async-admin-pages-issue-type-schemes-directory" */ '@jira/spa-apps__admin-pages-issue-types-issue-type-schemes-directory/src/IssueTypeSchemesDirectory.tsx'
		),
	),
);

const AsyncIssueTypeSchemesDirectory = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIssueTypeSchemesDirectory}
		pageId="jira-admin-pages-issue-type-schemes-directory"
		shouldShowSpinner
	/>
);

export default AsyncIssueTypeSchemesDirectory;
